import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { ISupplier } from 'types';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeSupplierName: (value: string) => void;
	supplierTaxpayerId: ISupplier['taxpayerId'];
	supplierPhone: ISupplier['phone'];
}

export const SupplierNameField: React.FC<IProps> = React.memo(
	({ changeSupplierName, supplierTaxpayerId, supplierPhone }) => {
		const { t } = useTranslation('error');

		const validationRules = useMemo<Rule[]>(
			() => [{ required: !!(supplierTaxpayerId || supplierPhone), message: t('enterName') }],
			[t, supplierTaxpayerId, supplierPhone],
		);

		return (
			<FormInput
				testId="SupplierNameField"
				name="supplierName"
				label="supplierNameLabel"
				onChange={changeSupplierName}
				validationRules={validationRules}
			/>
		);
	},
);
